const config = {
    PROJECT_NAME: '版权登记', // 应用名
    PROJECT_BASE_URL: 'https://bqsb.rarb.cn' // 应用服务前缀
    // PROJECT_BASE_URL: 'http://localhost:8060' // 应用服务前缀
    // PROJECT_BASE_URL: 'https://bqdj.rarb.cn' // 应用服务前缀
    // PROJECT_BASE_URL: 'http://10.102.12.68:8060' // 应用服务前缀
};
export default config;
